export const FETCH_RX_PRODUCT_URL = "/api/product/"
export const POST_RX_DISCOUNT_URL = "/api/discount/"
export const POST_RX_ORDER_URL = "/api/order/"

export type RxProduct = {
    product_id: string;
    title: string;
    price: string;
    image: Image[];
    variant: Variant[];

}

type Image = {
    position: string;
    image_data: string;
    thumbnail_data: string;
}

type Variant = {
    variant_id: string;
    title: string;
    price: string;
}


export type RXValues = {
    discountCode : string;
    discountAmount : number;
    email : string;
    qty : number;
    itemLines : ItemLine[];
    pdErrorIndices: { [key: string]: boolean };
}
export type ItemLine = {
    name: string;
    inputs: LineInput[];
};
export type LineInput = {
    title: string;
    sph: string;
    cyl: string;
    axis: string;
    add: string;
    pd: string;
};
export const INITIAL_RX_ITEM_LINE : ItemLine = ({
    name: "",
    inputs: [
        { title: "OD", sph: "", cyl: "", axis: "", add: "", pd: "" },
        { title: "OS", sph: "", cyl: "", axis: "", add: "", pd: "" },
    ],
});

export const INITIAL_RX_VALUES: RXValues = {
    discountCode: "",
    discountAmount: 0,
    email: "",
    qty: 1,
    itemLines: [ INITIAL_RX_ITEM_LINE],
    pdErrorIndices: {},
};


